import { values } from './enums'

const _enum = {
  Error: 0,
  Warning: 1,
  Information: 2
}

export const checkingRuleSeverity = {
  enumName: 'CheckingRuleSeverity',
  enum: _enum,
  values: values(_enum)
}



// WEBPACK FOOTER //
// ./src/enums/checkingRuleSeverity.js